import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class Framework extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'Framework'
  // Define default properties here
  static instanceDefaults () {
    return {
      title: '',
      isEnabled: false,
      ownerOrganizationId: null,
      hasActions: true,
      hasQuestions: false,
      steps: 10,
      viewMode: 'stacked',
      maxValue: 100,
      roundToStep: false,
    }
  }
}
const servicePath = 'frameworks'
const servicePlugin = makeServicePlugin({
  Model: Framework,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    // hardcode viewMode to 'stacked' if id is 4
    find: [context => {
      context.result.data.forEach(item => {
        if (item.id === 4) {
          item.viewMode = 'stacked'
        }
      })
    }],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
